import ws from '@api/webservice'
import config from '@app/config'

const api = {
  refresh: (body: LoginRefreshRequest) =>
    ws<LoginRefreshSuccessResponse>(config.ws.authentification.refresh, 'PUT', body),
  login: (body: LoginRequest) => ws<LoginSuccessResponse>(config.ws.authentification.login, 'POST', body),
  me: () => ws<UserResponse>(config.ws.authentification.me, 'GET'),
  guest: () => ws<LoginSuccessResponse>(config.ws.authentification.guest, 'GET'),

  // SSO pour les exposants
  ssoInfo: () => ws<LoginSsoResponse>(config.ws.authentification.ssoInfo, 'GET'),
  ssoToken: (body: SsoToken) => ws<LoginSuccessResponse>(config.ws.authentification.ssoInfo, 'POST', body),

  // Mot de passe oublié
  forgottenPassword: (email: string) =>
    ws<void>(
      `${config.ws.authentification.forgottenPassword}${email ? `?email=${encodeURIComponent(email)}` : ''}`,
      'POST'
    ),
  verifyToken: (body: TokenRequest) => ws<void>(config.ws.authentification.verifyResetPasswordToken, 'POST', body),
  resetPassword: (body: ResetPasswordRequest) => ws<void>(config.ws.authentification.resetPassword, 'PUT', body),

  // not implemented
  isEmailKnown: (email: string) => Promise.resolve(true),
}

export default api
